export const en = {
  // Navigation
  home: "Home",
  about: "About",
  tours: "Tours",
  deals: "Deals",
  testimonials: "Testimonials",
  blog: "Blog",
  contact: "Contact",
  
  // Company
  companyName: "Lanka Travel",
  
  // Home page
  welcomeTitle: "Welcome to Sri Lanka",
  welcomeSubtitle: "Discover the beauty of the pearl of the Indian Ocean",
  exploreButton: "Explore Tours",
  learnMoreButton: "Learn More",
  
  // About page
  aboutTitle: "About Us",
  aboutSubtitle: "Your trusted travel partner in Sri Lanka",
  aboutDescription: "We specialize in creating unforgettable travel experiences across Sri Lanka, from pristine beaches to ancient temples.",
  
  // Tours page
  toursTitle: "Our Tours",
  toursSubtitle: "Discover amazing destinations",
  bookNow: "Book Now",
  viewDetails: "View Details",
  
  // Contact page
  contactTitle: "Contact Us",
  contactSubtitle: "Get in touch with us",
  name: "Name",
  email: "Email",
  message: "Message",
  send: "Send Message",
  phone: "Phone",
  address: "Address",
  
  // Testimonials
  testimonialsTitle: "What Our Customers Say",
  testimonialsSubtitle: "Real experiences from real travelers",
  
  // Blog
  blogTitle: "Travel Blog",
  blogSubtitle: "Latest travel stories and tips",
  readMore: "Read More",
  
  // Common
  loading: "Loading...",
  error: "An error occurred",
  success: "Success!",
  close: "Close",
  submit: "Submit",
  cancel: "Cancel",
  
  // Language selector
  selectLanguage: "Select Language",
  english: "English",
  sinhala: "සිංහල",
  korean: "한국어",
  italian: "Italiano",
  
  // About Us Page
  whyChooseTitle: "Why Choose Lanka Travel?",
  whyChooseSubtitle: "We are committed to providing you with the best travel experiences with exceptional service and personalized packages.",
  personalizedTitle: "Personalized Travel Planning",
  personalizedDesc: "We tailor each journey to suit your unique needs, ensuring a one-of-a-kind travel experience.",
  customerSupportTitle: "24/7 Customer Support",
  customerSupportDesc: "Our dedicated travel experts are available around the clock to assist you with any queries.",
  destinationsTitle: "Handpicked Destinations",
  destinationsDesc: "Explore the best destinations carefully selected to offer you unforgettable experiences.",
  priceGuaranteeTitle: "Best Price Guarantee",
  priceGuaranteeDesc: "We offer competitive prices without compromising on the quality of your travel experience.",
  luxuryTitle: "Luxury & Comfort",
  luxuryDesc: "Enjoy luxurious accommodations and seamless travel arrangements for ultimate comfort.",
  guidesTitle: "Expert Tour Guides",
  guidesDesc: "Our knowledgeable and friendly guides ensure you make the most of your trip.",
  
  // Contact Page
  getInTouchTitle: "Get in Touch with Lanka Travel",
  loveToHearTitle: "We'd Love to Hear From You",
  loveToHearDesc: "Whether you have a question about our tours, pricing, or anything else, our team is ready to answer all your questions.",
  office: "Office",
  phone: "Phone",
  support: "Support",
  email: "Email",
  officeAddress: "Watabage Junction, Panadura, Sri Lanka",
  phoneNumber: "+94 72 051 2976",
  supportNumber: "+94 72 051 2976",
  emailAddress: "lankatravelhub.lk@gmail.com",
  contactFormTitle: "Send us a Message",
  contactFormDesc: "Fill out the form below and we'll get back to you as soon as possible.",
  namePlaceholder: "Your Name",
  emailPlaceholder: "Your Email",
  phonePlaceholder: "Your Phone Number",
  messagePlaceholder: "Your Message",
  submitButton: "Send Message",
  submitting: "Sending...",
  messageSent: "Message sent successfully!",
  messageError: "Failed to send message. Please try again.",
  
  // Testimonials Page
  customerReviewsTitle: "What Our Customers Say",
  customerReviewsSubtitle: "Real experiences from real travelers who have explored Sri Lanka with us",
  
  // Blog Page
  travelBlogTitle: "Travel Blog",
  travelBlogSubtitle: "Latest travel stories, tips, and insights from our adventures in Sri Lanka",
  
  // Tours Page
  ourToursTitle: "Our Tours",
  ourToursSubtitle: "Discover amazing destinations and unforgettable experiences",
  
  // Deals Page
  specialDealsTitle: "Special Deals",
  specialDealsSubtitle: "Exclusive offers and discounts on our best tours",
  
  // Tour Content
  culturalTourTitle: "Sri Lanka Cultural Tour",
  culturalTourDesc: "Experience the rich heritage and historical sites of Sri Lanka in this cultural tour.",
  wildlifeTourTitle: "Wildlife Safari Adventure",
  wildlifeTourDesc: "Explore Sri Lanka's famous wildlife parks and witness exotic animals in their natural habitat.",
  beachTourTitle: "Beach Getaway",
  beachTourDesc: "Relax on the most beautiful beaches of Sri Lanka with crystal-clear waters and golden sands.",
  hillCountryTourTitle: "Hill Country Adventure",
  hillCountryTourDesc: "Discover the scenic beauty of Sri Lanka's mountains, waterfalls, and tea plantations.",
  honeymoonTourTitle: "Luxury Honeymoon Package",
  honeymoonTourDesc: "Enjoy a romantic and luxurious honeymoon experience in Sri Lanka's finest resorts.",
  adventureTourTitle: "Adventure & Trekking Tour",
  adventureTourDesc: "Embark on thrilling trekking adventures and outdoor activities in Sri Lanka.",
  
  // Deal Content
  exclusiveHoneymoonTitle: "Exclusive Sri Lanka Honeymoon Package",
  exclusiveHoneymoonDesc: "Enjoy a luxurious honeymoon with romantic getaways, beach resorts, and cultural experiences.",
  adventureWildlifeTitle: "Adventure & Wildlife Tour",
  adventureWildlifeDesc: "Explore the wilderness of Sri Lanka with exciting safaris and nature expeditions.",
  luxuryBeachTitle: "Luxury Beach Vacation",
  luxuryBeachDesc: "Relax on the finest beaches, enjoy water sports, and experience top-notch hospitality.",
  culturalHeritageTitle: "Cultural Heritage Tour",
  culturalHeritageDesc: "Visit Sri Lanka's UNESCO heritage sites, ancient temples, and vibrant cities.",
  budgetFamilyTitle: "Budget Family Vacation",
  budgetFamilyDesc: "An affordable family-friendly package with exciting activities for all ages.",
  ultimateAdventureTitle: "Ultimate Adventure Tour",
  ultimateAdventureDesc: "Trekking, rafting, and adventure sports in Sri Lanka's stunning landscapes.",
  
  // Blog Content
  exploringBeautyTitle: "Exploring the Beauty of Sri Lanka",
  exploringBeautyExcerpt: "Discover the breathtaking landscapes, rich history, and cultural wonders of Sri Lanka in this comprehensive travel guide.",
  bestBeachesTitle: "Best Beaches in Sri Lanka",
  bestBeachesExcerpt: "From golden sandy shores to stunning turquoise waters, explore the best beach destinations in Sri Lanka for a perfect getaway.",
  wildlifeSafariTitle: "Wildlife Safari Adventures",
  wildlifeSafariExcerpt: "Experience the thrill of spotting elephants, leopards, and exotic birds in Sri Lanka's renowned national parks.",
  
  // Testimonial Content
  johnReview: "Our trip to Sri Lanka was absolutely fantastic! The planning and organization were perfect, and we felt well taken care of throughout the journey. Highly recommend Lanka Travel!",
  emmaReview: "A truly memorable experience! From the beautiful beaches to the stunning cultural sites, everything was perfectly planned. Can't wait to visit again!",
  carlosReview: "The best travel agency I've ever booked with! Everything was well organized, and the guides were knowledgeable and friendly. Thank you for an amazing experience!",
  sophiaReview: "A seamless and unforgettable trip! The team was professional, and the itinerary was well thought out. I highly recommend Lanka Travel to anyone visiting Sri Lanka.",
  
  // Common Labels
  activities: "Activities",
  duration: "Duration",
  price: "Price",
  workingHours: "Working Hours",
  workingHoursText: "Monday – Friday: 9:00 AM – 6:00 PM",
  
  // Highlights Tour
  fiveDayHighlightsTitle: "Highlights of Sri Lanka",
  fiveDayHighlightsSubtitle: "Highlights: Katunayake, Sigiriya, Kandy, Ella, Galle. A compact journey through Sri Lanka's must-see destinations.",
  bookNow: "Book Now",
  
  // Katunayake
  day1Title: "Arrival",
  katunayakeTitle: "Katunayake",
  katunayakeStay: "Comfortable stay near Katunayake",
  katunayakeActivities: "Activities",
  katunayakeArrival: "Arrival at Bandaranaike International Airport",
  katunayakeMeetGreet: "Meet and greet, transfer to nearby stay",
  katunayakeNegombo: "Optional visit to Negombo Beach (time permitting)",
  katunayakeRest: "Rest and recover from flight",
  katunayakeLocation: "Katunayake - Bandaranaike International Airport",
  katunayakeDescription: "Start your Sri Lankan highlights with a convenient first night near the airport.",
  
  // Sigiriya
  day2Title: "Sigiriya",
  sigiriyaTitle: "Sigiriya",
  sigiriyaStay: "Guesthouse in Sigiriya",
  sigiriyaTransfer: "Transfer to Sigiriya",
  sigiriyaClimb: "Climb the Sigiriya Rock Fortress",
  sigiriyaExplore: "Explore the water gardens and frescoes",
  sigiriyaVillage: "Village experience or bicycle ride (optional)",
  sigiriyaLocation: "Sigiriya Rock Fortress",
  sigiriyaDescription: "Iconic UNESCO World Heritage site with sweeping views.",
  
  // Kandy
  day3Title: "Kandy",
  kandyTitle: "Kandy",
  kandyStay: "Hotel in Kandy",
  kandyTransfer: "Transfer to Kandy",
  kandyTemple: "Temple of the Sacred Tooth Relic",
  kandyGardens: "Royal Botanical Gardens, Peradeniya",
  kandyLake: "Kandy Lake walk and local market",
  kandyLocation: "Temple of the Sacred Tooth Relic, Kandy",
  kandyDescription: "Cultural capital with sacred heritage and lush gardens.",
  
  // Ella
  day4Title: "Ella",
  ellaTitle: "Ella",
  ellaStay: "Cozy stay in Ella",
  ellaTrain: "Scenic train journey to Ella",
  ellaPeak: "Little Adam's Peak hike",
  ellaBridge: "Nine Arches Bridge viewpoint",
  ellaExplore: "Explore tea country vibes in town",
  ellaLocation: "Scenic train near Ella",
  ellaDescription: "Cool-climate hill escape with stunning mountain scenery.",
  
  // Galle
  day5Title: "Galle",
  galleTitle: "Galle",
  galleStay: "Hotel in Galle (or late departure)",
  galleTransfer: "Transfer to Galle",
  galleFort: "Explore the UNESCO-listed Galle Fort",
  galleLighthouse: "Lighthouse and ramparts walk",
  galleCafes: "Cafés, boutiques, and seaside views",
  galleContinue: "Continue to airport or extend beach stay",
  galleLocation: "Galle Fort ramparts and lighthouse",
  galleDescription: "Historic coastal charm to wrap up your highlights",
  
  // Colombo Tour
  threeDayColomboTitle: "Colombo Trip - Sri Lanka",
  threeDayColomboSubtitle: "Experience the best of Colombo with luxury hotels, cultural visits, shopping, and relaxation by the ocean.",
  
  // Colombo
  dayOneTitle: "Arrival",
  dayTwoTitle: "City Tour", 
  dayThreeTitle: "Departure",
  
  // Day One Activities
  colomboArrival: "Arrival at Bandaranaike International Airport",
  colomboTransfer: "Transfer to hotel and check-in",
  colomboFort: "Explore Colombo Fort area – colonial buildings, markets, and shopping",
  colomboDinner: "Dinner at hotel restaurant and overnight stay.",
  
  // Day Two Activities
  colomboBreakfast: "Breakfast at hotel",
  colomboTemple: "Visit Gangaramaya Temple and museum",
  colomboLunch: "Lunch at local restaurant",
  colomboMuseum: "Afternoon visit to National Museum and Viharamahadevi Park",
  colomboOvernight: "Dinner and overnight stay.",
  
  // Day Three Activities
  colomboRelax: "Relax at Galle Face Green and watch the ocean",
  colomboShopping: "Shopping at Odel or Barefoot Gallery",
  colomboPrepare: "Prepare for departure",
  colomboCheckout: "Check-out and transfer to airport.",
  
  // Hotels
  cinnamonGrand: "Cinnamon Grand Colombo",
  shangriLa: "Shangri-La Colombo",
  kingsbury: "The Kingsbury Colombo",
  
  // Tour Packages
  fiveDayBudgetPackTitle: "Budget Pack (Highlights of Sri Lanka)",
  fiveDayBudgetPackSubtitle: "Highlights",
  fiveDayBudgetPackFeatures: "🏨 ✈ 🚗 🍽",
  fiveDayBudgetPackType: "Budget",
  fiveDayBudgetPackHighlights: "Highlights",
  fiveDayBudgetPackCulture: "Culture",
  fiveDayBudgetPackHistory: "History",
  fiveDayBudgetPackNature: "Nature",
  fiveDayBudgetPackPrice: "From US $650 Per Person",
  moreInformation: "More Information ➜",
  
  threeDayColomboCityTitle: "Colombo City Experience",
  threeDayColomboCitySubtitle: "City Tour",
  threeDayColomboCityFeatures: "🏨 ✈ 🚗 🍽",
  threeDayColomboCityType: "City Tour",
  threeDayColomboCityCulture: "Culture",
  threeDayColomboCityShopping: "Shopping",
  threeDayColomboCityLuxury: "Luxury Hotels",
  threeDayColomboCitySightseeing: "Sightseeing",
  threeDayColomboCityPrice: "From US $350 Per Person",
  
  familyTripTitle: "Family Trip to Sri Lanka",
  familyTripSubtitle: "Family Package",
  familyTripFeatures: "🏨 ✈ 🚗 🍽",
  familyTripWildlife: "Wild Life",
  familyTripNature: "Nature",
  familyTripCulture: "Culture",
  familyTripHistory: "History",
  familyTripPrice: "From US $850 Per Person",
  
  bestOfSriLankaTitle: "Best of Sri Lanka",
  bestOfSriLankaSubtitle: "Comprehensive",
  bestOfSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  bestOfSriLankaBeach: "Beach",
  bestOfSriLankaWildlife: "Wild Life",
  bestOfSriLankaNature: "Nature",
  bestOfSriLankaCulture: "Culture",
  bestOfSriLankaPrice: "From US $1250 Per Person",
  
  romanticGetawayTitle: "Romantic Getaway in Sri Lanka",
  romanticGetawaySubtitle: "Romantic Package",
  romanticGetawayFeatures: "🏨 ✈ 🚗 🍽",
  romanticGetawayNature: "Nature",
  romanticGetawayBeach: "Beach",
  romanticGetawayWildlife: "Wild Life",
  romanticGetawayHistory: "History",
  romanticGetawayPrice: "From US $1700 Per Person",
  
  // Why Choose Us
  whyChooseUsTitle: "Why Choose Us",
  whyChooseUsSubtitle: "A number of people have chosen us as their number one travel destination management company, and you will also choose us for the following reasons.",
  
  whyChooseUsReason1: "We have a passionate and professional team of 40 representatives with extensive knowledge of Sri Lanka tourism.",
  whyChooseUsReason2: "We are one of the leading travel agents in Sri Lanka.",
  whyChooseUsReason3: "We provide custom-made & specialized tours to our clients.",
  whyChooseUsReason4: "We are a leading travel agent in Sri Lanka who provides tours and holiday packages to exotic destinations.",
  whyChooseUsReason5: "We offer 24/7 customer support to our clients.",
  whyChooseUsReason6: "We provide custom-made & specialized tours to our clients.",
  whyChooseUsReason7: "We are a leading travel agent in Sri Lanka who provides tours and holiday packages to exotic destinations.",
  whyChooseUsReason8: "We offer 24/7 customer support to our clients.",
  
  
  // How It Works
  howItWorksTitle: "HOW IT WORKS?",
  
  // Common UI elements
  days: "Days",
  from: "From",
  perPerson: "Per Person",
  
  step1Title: "1. Enquire Now",
  step1Time: "5 Minutes",
  step1FillingForm: "Filling the web form",
  step1WebChat: "Web live chat",
  step1Email: "Email",
  step1Call: "Call us",
  
  step2Title: "2. Connect Travel Expert",
  step2Time: "30 Minutes",
  step2Discuss: "Discuss your requirement",
  step2FreeAdvice: "Free expert travel advice",
  step2Support: "24/7 Support",
  
  step3Title: "3. Received 3 Travel Options",
  step3Discuss: "Discuss changes",
  step3Finalise: "Finalise trip plan",
  step3Pay: "Pay 10%",
  
  step4Title: "4. Receive Your Trip Confirmation",
  step4FillingForm: "Filling the web form",
  step4Satisfaction: "100% satisfaction guaranteed",
  
  // Complete Sri Lanka Circuit Tour
  completeSriLankaTitle: "Complete Sri Lanka Circuit",
  completeSriLankaSubtitle: "Comprehensive",
  completeSriLankaFeatures: "🏨 ✈ 🚗 🍽",
  completeSriLankaType: "Comprehensive",
  completeSriLankaHighlights: "Highlights",
  completeSriLankaCulture: "Culture",
  completeSriLankaHistory: "History",
  completeSriLankaNature: "Nature",
  completeSriLankaBeach: "Beach",
  completeSriLankaPrice: "From US $1850 Per Person",
  
  // Complete Sri Lanka Circuit Details
  completeSriLankaCircuitTitle: "Complete Sri Lanka Circuit",
  completeSriLankaCircuitSubtitle: "Experience the complete beauty of Sri Lanka with this comprehensive journey covering all major destinations.",
  
  // Day 2 - Anuradhapura
  ancientCityTitle: "Anuradhapura",
  ancientCityStay: "Hotel in Anuradhapura",
  ancientCityTransfer: "Transfer to Anuradhapura",
  ancientCityExplore: "Explore ancient ruins and stupas",
  ancientCityTemple: "Visit Sri Maha Bodhi tree",
  ancientCityMuseum: "Visit Archaeological Museum",
  ancientCityLocation: "Anuradhapura Ancient City",
  ancientCityDescription: "Discover Sri Lanka's ancient capital and UNESCO World Heritage site.",
  
  // Nuwara Eliya
  nuwaraEliyaTitle: "Nuwara Eliya",
  nuwaraEliyaStay: "Hotel in Nuwara Eliya",
  nuwaraEliyaTransfer: "Transfer to Nuwara Eliya",
  nuwaraEliyaTea: "Visit tea plantations and factory",
  nuwaraEliyaLake: "Explore Gregory Lake",
  nuwaraEliyaExplore: "Explore Little England",
  nuwaraEliyaLocation: "Nuwara Eliya Tea Country",
  nuwaraEliyaDescription: "Experience the cool climate and tea country charm of Little England.",
  
  // Ella
  day6Title: "Ella",
  
  // Ella (Second Day)
  day7Title: "Ella Extended",
  ellaWaterfall: "Visit Ravana Falls",
  ellaTea: "Tea plantation tour",
  ellaRelax: "Relax and enjoy the mountain views",
  ellaLocal: "Local village experience",
  ellaDay2Description: "Second day in Ella to explore waterfalls and tea country.",
  
  // Mirissa
  day8Title: "Mirissa",
  mirissaTitle: "Mirissa",
  mirissaStay: "Beach resort in Mirissa",
  mirissaTransfer: "Transfer to Mirissa",
  mirissaBeach: "Relax on Mirissa Beach",
  mirissaWhale: "Whale watching tour (seasonal)",
  mirissaRelax: "Beach relaxation and sunset",
  mirissaLocation: "Mirissa Beach",
  mirissaDescription: "Enjoy the beautiful beaches and whale watching opportunities.",
  
  // Mirissa (Second Day)
  day9Title: "Mirissa Extended",
  mirissaSnorkel: "Snorkeling and water sports",
  mirissaDiving: "Scuba diving (optional)",
  mirissaSunset: "Sunset beach walk",
  mirissaDay2Description: "Second day in Mirissa for water activities and beach relaxation.",
  
  // Galle
  day10Title: "Galle",
  
  // Galle (Second Day)
  day11Title: "Galle Extended",
  galleShopping: "Shopping in Galle Fort",
  galleMuseum: "Visit Galle Maritime Museum",
  galleBeach: "Beach time at Unawatuna",
  galleDining: "Dining at fort restaurants",
  galleDay2Description: "Second day in Galle to explore more of the historic fort.",
  
  // Bentota
  day12Title: "Bentota",
  bentotaTitle: "Bentota",
  bentotaStay: "Resort in Bentota",
  bentotaTransfer: "Transfer to Bentota",
  bentotaRiver: "Bentota River safari",
  bentotaBeach: "Beach activities",
  bentotaSpa: "Spa and wellness treatments",
  bentotaLocation: "Bentota Beach Resort",
  bentotaDescription: "Relax at the beautiful beach resort with river activities.",
  
  // Colombo
  day13Title: "Colombo",
  colomboTitle: "Colombo",
  colomboStay: "Hotel in Colombo",
  colomboLocation: "Colombo City",
  colomboDescription: "Explore the capital city's attractions and shopping.",
  
  // Departure
  day14Title: "Departure",
  departureTitle: "Departure",
  departureStay: "Airport hotel or departure",
  departureBreakfast: "Final breakfast",
  departureShopping: "Last minute shopping",
  departureTransfer: "Transfer to airport",
  departureAirport: "Departure from Bandaranaike International Airport",
  departureLocation: "Bandaranaike International Airport",
  departureDescription: "Final day with airport transfer and departure.",
  
  // Wildlife & Cultural Heritage Tour
  wildlifeCulturalTitle: "Wildlife & Cultural Heritage Tour",
  wildlifeCulturalSubtitle: "Wildlife & Culture",
  wildlifeCulturalFeatures: "🏨 ✈ 🚗 🍽",
  wildlifeCulturalType: "Wildlife & Culture",
  wildlifeCulturalHighlights: "Highlights",
  wildlifeCulturalWildlife: "Wildlife",
  wildlifeCulturalCulture: "Culture",
  wildlifeCulturalHistory: "History",
  wildlifeCulturalNature: "Nature",
  wildlifeCulturalBeach: "Beach",
  wildlifeCulturalPrice: "From US $1450 Per Person",
  
  // Wildlife & Cultural Heritage Details
  wildlifeCulturalCircuitTitle: "Wildlife & Cultural Heritage Tour",
  wildlifeCulturalCircuitSubtitle: "Experience Sri Lanka's wildlife, ancient cities, and cultural heritage in this comprehensive journey.",
  
  // Day 2 - Udawalawe
  udawalaweTitle: "Udawalawe",
  udawalaweStay: "Safari lodge in Udawalawe",
  udawalaweTransfer: "Transfer to Udawalawe",
  udawalaweSafari: "Udawalawe National Park safari",
  udawalaweElephants: "Elephant watching and photography",
  udawalaweBirds: "Bird watching tour",
  udawalaweLocation: "Udawalawe National Park",
  udawalaweDescription: "Experience Sri Lanka's wildlife with elephants, birds, and other animals in their natural habitat.",
  
  // Day 3 - Ella
  ellaWildlifeTitle: "Ella",
  ellaWildlifeStay: "Hotel in Ella",
  ellaWildlifeTransfer: "Transfer to Ella",
  ellaWildlifeTrain: "Scenic train journey to Ella",
  ellaWildlifePeak: "Little Adam's Peak hike",
  ellaWildlifeBridge: "Nine Arches Bridge viewpoint",
  ellaWildlifeLocation: "Ella Hill Station",
  ellaWildlifeDescription: "Explore the beautiful hill country with stunning mountain views and tea plantations.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaWildlifeTitle: "Nuwara Eliya",
  nuwaraEliyaWildlifeStay: "Hotel in Nuwara Eliya",
  nuwaraEliyaWildlifeTransfer: "Transfer to Nuwara Eliya",
  nuwaraEliyaWildlifeTea: "Tea plantation and factory tour",
  nuwaraEliyaWildlifeLake: "Gregory Lake boat ride",
  nuwaraEliyaWildlifeExplore: "Explore Little England",
  nuwaraEliyaWildlifeLocation: "Nuwara Eliya Tea Country",
  nuwaraEliyaWildlifeDescription: "Experience the cool climate and tea country charm of Little England.",
  
  // Day 5 - Kandy
  kandyWildlifeTitle: "Kandy",
  kandyWildlifeStay: "Hotel in Kandy",
  kandyWildlifeTransfer: "Transfer to Kandy",
  kandyWildlifeTemple: "Temple of the Sacred Tooth Relic",
  kandyWildlifeGardens: "Royal Botanical Gardens",
  kandyWildlifeLake: "Kandy Lake walk",
  kandyWildlifeLocation: "Temple of the Sacred Tooth Relic",
  kandyWildlifeDescription: "Cultural capital with sacred heritage and lush gardens.",
  
  // Day 6 - Sigiriya
  sigiriyaWildlifeTitle: "Sigiriya",
  sigiriyaWildlifeStay: "Hotel in Sigiriya",
  sigiriyaWildlifeTransfer: "Transfer to Sigiriya",
  sigiriyaWildlifeClimb: "Climb the Sigiriya Rock Fortress",
  sigiriyaWildlifeExplore: "Explore water gardens and frescoes",
  sigiriyaWildlifeVillage: "Village experience",
  sigiriyaWildlifeLocation: "Sigiriya Rock Fortress",
  sigiriyaWildlifeDescription: "Iconic UNESCO World Heritage site with sweeping views.",
  
  // Day 7 - Anuradhapura
  anuradhapuraWildlifeTitle: "Anuradhapura",
  anuradhapuraWildlifeStay: "Hotel in Anuradhapura",
  anuradhapuraWildlifeTransfer: "Transfer to Anuradhapura",
  anuradhapuraWildlifeExplore: "Explore ancient ruins and stupas",
  anuradhapuraWildlifeTemple: "Visit Sri Maha Bodhi tree",
  anuradhapuraWildlifeMuseum: "Archaeological Museum",
  anuradhapuraWildlifeLocation: "Anuradhapura Ancient City",
  anuradhapuraWildlifeDescription: "Discover Sri Lanka's ancient capital and UNESCO World Heritage site.",
  
  // Day 8 - Polonnaruwa
  polonnaruwaTitle: "Polonnaruwa",
  polonnaruwaStay: "Hotel in Polonnaruwa",
  polonnaruwaTransfer: "Transfer to Polonnaruwa",
  polonnaruwaExplore: "Explore ancient city ruins",
  polonnaruwaGalVihara: "Visit Gal Vihara rock temple",
  polonnaruwaMuseum: "Archaeological Museum",
  polonnaruwaLocation: "Polonnaruwa Ancient City",
  polonnaruwaDescription: "Explore the medieval capital with well-preserved ruins and sculptures.",
  
  // Day 9 - Trincomalee
  trincomaleeTitle: "Trincomalee",
  trincomaleeStay: "Beach resort in Trincomalee",
  trincomaleeTransfer: "Transfer to Trincomalee",
  trincomaleeBeach: "Relax on beautiful beaches",
  trincomaleeWhale: "Whale watching (seasonal)",
  trincomaleeFort: "Visit Trincomalee Fort",
  trincomaleeLocation: "Trincomalee Beach",
  trincomaleeDescription: "Enjoy the beautiful beaches and historical sites of the east coast.",
  
  // Day 10 - Colombo
  colomboWildlifeTitle: "Colombo",
  colomboWildlifeStay: "Hotel in Colombo",
  colomboWildlifeTransfer: "Transfer to Colombo",
  colomboWildlifeFort: "Explore Colombo Fort",
  colomboWildlifeTemple: "Visit Gangaramaya Temple",
  colomboWildlifeShopping: "Shopping and city tour",
  colomboWildlifeLocation: "Colombo City",
  colomboWildlifeDescription: "Explore the capital city's attractions and prepare for departure.",
  
  // Hill Country & Beach Adventure Tour
  hillCountryBeachTitle: "Hill Country & Beach Adventure",
  hillCountryBeachSubtitle: "Adventure",
  hillCountryBeachFeatures: "🏨 ✈ 🚗 🍽",
  hillCountryBeachType: "Adventure",
  hillCountryBeachHighlights: "Highlights",
  hillCountryBeachNature: "Nature",
  hillCountryBeachBeach: "Beach",
  hillCountryBeachCulture: "Culture",
  hillCountryBeachHistory: "History",
  hillCountryBeachAdventure: "Adventure",
  hillCountryBeachPrice: "From US $1200 Per Person",
  
  // Hill Country & Beach Adventure Details
  hillCountryBeachCircuitTitle: "Hill Country & Beach Adventure",
  hillCountryBeachCircuitSubtitle: "Experience the best of Sri Lanka's hill country and beautiful beaches in this exciting adventure.",
  
  // Day 2 - Sigiriya
  sigiriyaAdventureTitle: "Sigiriya",
  sigiriyaAdventureStay: "Hotel in Sigiriya",
  sigiriyaAdventureTransfer: "Transfer to Sigiriya",
  sigiriyaAdventureClimb: "Climb the Sigiriya Rock Fortress",
  sigiriyaAdventureExplore: "Explore water gardens and frescoes",
  sigiriyaAdventureVillage: "Village experience",
  sigiriyaAdventureLocation: "Sigiriya Rock Fortress",
  sigiriyaAdventureDescription: "Iconic UNESCO World Heritage site with sweeping views.",
  
  // Day 3 - Kandy
  kandyAdventureTitle: "Kandy",
  kandyAdventureStay: "Hotel in Kandy",
  kandyAdventureTransfer: "Transfer to Kandy",
  kandyAdventureTemple: "Temple of the Sacred Tooth Relic",
  kandyAdventureGardens: "Royal Botanical Gardens",
  kandyAdventureLake: "Kandy Lake walk",
  kandyAdventureLocation: "Temple of the Sacred Tooth Relic",
  kandyAdventureDescription: "Cultural capital with sacred heritage and lush gardens.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaAdventureTitle: "Nuwara Eliya",
  nuwaraEliyaAdventureStay: "Hotel in Nuwara Eliya",
  nuwaraEliyaAdventureTransfer: "Transfer to Nuwara Eliya",
  nuwaraEliyaAdventureTea: "Tea plantation and factory tour",
  nuwaraEliyaAdventureLake: "Gregory Lake boat ride",
  nuwaraEliyaAdventureExplore: "Explore Little England",
  nuwaraEliyaAdventureLocation: "Nuwara Eliya Tea Country",
  nuwaraEliyaAdventureDescription: "Experience the cool climate and tea country charm of Little England.",
  
  // Day 5 - Ella
  ellaAdventureTitle: "Ella",
  ellaAdventureStay: "Hotel in Ella",
  ellaAdventureTransfer: "Transfer to Ella",
  ellaAdventureTrain: "Scenic train journey to Ella",
  ellaAdventurePeak: "Little Adam's Peak hike",
  ellaAdventureBridge: "Nine Arches Bridge viewpoint",
  ellaAdventureLocation: "Ella Hill Station",
  ellaAdventureDescription: "Explore the beautiful hill country with stunning mountain views and tea plantations.",
  
  // Day 6 - Arugam Bay
  arugamBayTitle: "Arugam Bay",
  arugamBayStay: "Beach resort in Arugam Bay",
  arugamBayTransfer: "Transfer to Arugam Bay",
  arugamBaySurf: "Surfing lessons and beach activities",
  arugamBayBeach: "Relax on Arugam Bay beach",
  arugamBaySunset: "Sunset beach walk",
  arugamBayLocation: "Arugam Bay Beach",
  arugamBayDescription: "Enjoy the famous surfing beach and beautiful east coast scenery.",
  
  // Day 7 - Mirissa
  mirissaAdventureTitle: "Mirissa",
  mirissaAdventureStay: "Beach resort in Mirissa",
  mirissaAdventureTransfer: "Transfer to Mirissa",
  mirissaAdventureBeach: "Relax on Mirissa Beach",
  mirissaAdventureWhale: "Whale watching tour (seasonal)",
  mirissaAdventureSnorkel: "Snorkeling and water sports",
  mirissaAdventureLocation: "Mirissa Beach",
  mirissaAdventureDescription: "Enjoy the beautiful beaches and whale watching opportunities.",
  
  // Day 8 - Colombo
  colomboAdventureTitle: "Colombo",
  colomboAdventureStay: "Hotel in Colombo",
  colomboAdventureTransfer: "Transfer to Colombo",
  colomboAdventureFort: "Explore Colombo Fort",
  colomboAdventureTemple: "Visit Gangaramaya Temple",
  colomboAdventureShopping: "Shopping and city tour",
  colomboAdventureLocation: "Colombo City",
  colomboAdventureDescription: "Explore the capital city's attractions and prepare for departure.",
  
  // Cultural Triangle & Beach Relaxation Tour
  culturalTriangleBeachTitle: "Cultural Triangle & Beach Relaxation",
  culturalTriangleBeachSubtitle: "Culture & Beach",
  culturalTriangleBeachFeatures: "🏨 ✈ 🚗 🍽",
  culturalTriangleBeachType: "Culture & Beach",
  culturalTriangleBeachHighlights: "Highlights",
  culturalTriangleBeachCulture: "Culture",
  culturalTriangleBeachHistory: "History",
  culturalTriangleBeachBeach: "Beach",
  culturalTriangleBeachNature: "Nature",
  culturalTriangleBeachRelaxation: "Relaxation",
  culturalTriangleBeachPrice: "From US $950 Per Person",
  
  // Cultural Triangle & Beach Relaxation Details
  culturalTriangleBeachCircuitTitle: "Cultural Triangle & Beach Relaxation",
  culturalTriangleBeachCircuitSubtitle: "Experience Sri Lanka's cultural heritage and relax on beautiful beaches in this perfect combination tour.",
  
  // Day 2 - Sigiriya
  sigiriyaCulturalTitle: "Sigiriya",
  sigiriyaCulturalStay: "Hotel in Sigiriya",
  sigiriyaCulturalTransfer: "Transfer to Sigiriya",
  sigiriyaCulturalClimb: "Climb the Sigiriya Rock Fortress",
  sigiriyaCulturalExplore: "Explore water gardens and frescoes",
  sigiriyaCulturalVillage: "Village experience",
  sigiriyaCulturalLocation: "Sigiriya Rock Fortress",
  sigiriyaCulturalDescription: "Iconic UNESCO World Heritage site with sweeping views.",
  
  // Day 3 - Kandy
  kandyCulturalTitle: "Kandy",
  kandyCulturalStay: "Hotel in Kandy",
  kandyCulturalTransfer: "Transfer to Kandy",
  kandyCulturalTemple: "Temple of the Sacred Tooth Relic",
  kandyCulturalGardens: "Royal Botanical Gardens",
  kandyCulturalLake: "Kandy Lake walk",
  kandyCulturalLocation: "Temple of the Sacred Tooth Relic",
  kandyCulturalDescription: "Cultural capital with sacred heritage and lush gardens.",
  
  // Day 4 - Nuwara Eliya
  nuwaraEliyaCulturalTitle: "Nuwara Eliya",
  nuwaraEliyaCulturalStay: "Hotel in Nuwara Eliya",
  nuwaraEliyaCulturalTransfer: "Transfer to Nuwara Eliya",
  nuwaraEliyaCulturalTea: "Tea plantation and factory tour",
  nuwaraEliyaCulturalLake: "Gregory Lake boat ride",
  nuwaraEliyaCulturalExplore: "Explore Little England",
  nuwaraEliyaCulturalLocation: "Nuwara Eliya Tea Country",
  nuwaraEliyaCulturalDescription: "Experience the cool climate and tea country charm of Little England.",
  
  // Day 5 - Bentota
  bentotaCulturalTitle: "Bentota",
  bentotaCulturalStay: "Beach resort in Bentota",
  bentotaCulturalTransfer: "Transfer to Bentota",
  bentotaCulturalRiver: "Bentota River safari",
  bentotaCulturalBeach: "Beach activities and relaxation",
  bentotaCulturalSpa: "Spa and wellness treatments",
  bentotaCulturalLocation: "Bentota Beach Resort",
  bentotaCulturalDescription: "Relax at the beautiful beach resort with river activities and spa treatments.",
  
  // Day 6 - Colombo
  colomboCulturalTitle: "Colombo",
  colomboCulturalStay: "Hotel in Colombo",
  colomboCulturalTransfer: "Transfer to Colombo",
  colomboCulturalFort: "Explore Colombo Fort",
  colomboCulturalTemple: "Visit Gangaramaya Temple",
  colomboCulturalShopping: "Shopping and city tour",
  colomboCulturalLocation: "Colombo City",
  colomboCulturalDescription: "Explore the capital city's attractions and prepare for departure.",
  
  // Package 1
  package1Title: "Kandy & Sigiriya Cultural Escape",
  package1Duration: "2 nights 3 days",
  package1Charges: "Hotel and transport charges only",
  package1Hotel: "4 star hotel include bed, dinner & breakfast",
  package1Price: "Starting From: USD 780\nper 2 persons",
  package1Locations: [
    {
      name: "📍 Sigiriya",
      activities: [
        { title: "Sigiriya Rock Fortress", desc: "Climb the iconic UNESCO World Heritage site and enjoy breathtaking views from the top of this ancient rock fortress." },
        { title: "Dambulla Cave Temple", desc: "Explore a historic cave complex filled with beautiful Buddha statues and vibrant wall paintings." },
        { title: "Pidurangala Rock", desc: "Hike to the summit for a stunning panoramic view of Sigiriya Rock, especially popular at sunrise and sunset." },
        { title: "Cooking Class Experience", desc: "Learn how to prepare authentic Sri Lankan dishes with a local chef and enjoy the meal you create." }
      ]
    },
    {
      name: "📍 Kandy",
      activities: [
        { title: "Temple of the Tooth Relic", desc: "Visit one of Sri Lanka’s most sacred temples, home to the revered relic of Lord Buddha." },
        { title: "Wax Museum", desc: "Discover lifelike wax figures showcasing important historical and cultural personalities of Sri Lanka." },
        { title: "Sightseeing & Viewpoints (Arthur’s Seat)", desc: "Enjoy scenic city views from one of Kandy’s best viewpoints overlooking the lake and surrounding hills." },
        { title: "Ambuluwawa Tower", desc: "Climb this unique spiral tower for 360-degree views of mountains, forests, and villages." }
      ]
    }
  ],
  package1Activities: "Activities",
  
  // Package 2
  package2Title: "Sri Lanka Highlights Escape",
  package2Duration: "4 nights 5 days",
  package2Charges: "Hotel and transport charges only",
  package2Hotel: "4 star hotel include bed, dinner & breakfast",
  package2Price: "Starting From: USD 1130\nper 2 persons",
  package2Locations: [
    {
      name: "📍 Sigiriya",
      activities: [
        { title: "Sigiriya Rock Fortress", desc: "Climb the iconic UNESCO World Heritage site and enjoy breathtaking views from the top of this ancient rock fortress." },
        { title: "Dambulla Cave Temple", desc: "Explore a historic cave complex filled with beautiful Buddha statues and vibrant wall paintings." },
        { title: "Pidurangala Rock", desc: "Hike to the summit for a stunning panoramic view of Sigiriya Rock, especially popular at sunrise and sunset." },
        { title: "Cooking Class Experience", desc: "Learn how to prepare authentic Sri Lankan dishes with a local chef and enjoy the meal you create." }
      ]
    },
    {
      name: "📍 Kandy",
      activities: [
        { title: "Temple of the Tooth Relic", desc: "Visit one of Sri Lanka’s most sacred temples, home to the revered relic of Lord Buddha." },
        { title: "Wax Museum", desc: "Discover lifelike wax figures showcasing important historical and cultural personalities of Sri Lanka." },
        { title: "Sightseeing & Viewpoints (Arthur’s Seat)", desc: "Enjoy scenic city views from one of Kandy’s best viewpoints overlooking the lake and surrounding hills." },
        { title: "Ambuluwawa Tower", desc: "Climb this unique spiral tower for 360-degree views of mountains, forests, and villages." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Relax by the lake with optional boat rides and outdoor activities in a cool, scenic environment." },
        { title: "Victoria Park", desc: "Take a peaceful walk through a well-maintained park filled with flowers, greenery, and birdlife." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit this famous colonial-era railway bridge surrounded by lush jungle—perfect for photos and train spotting." },
        { title: "Ravana Pool Club", desc: "Unwind at a stylish pool club with mountain views, music, and a relaxing atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by one of Sri Lanka’s most beautiful waterfalls, ideal for photos and a refreshing break." },
        { title: "Ella Sightseeing", desc: "Explore the charming hill town with scenic views, cafes, and nature spots." }
      ]
    }
  ],
  package2Activities: "Activities",
  
  // Package 3
  package3Title: "Southern Coast & Safari Escape",
  package3Duration: "3 nights 4 days",
  package3Charges: "Hotel and transport charges only",
  package3Hotel: "4 star hotel include bed, dinner & breakfast",
  package3Price: "Starting From: USD 895\nper 2 persons",
  package3Locations: [
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Relax on golden sandy beaches, swim in clear waters, or enjoy a peaceful sunset by the ocean." },
        { title: "Coconut Tree Hill", desc: "Visit a picturesque hill lined with palm trees, one of the most Instagram-famous spots in Sri Lanka." },
        { title: "Parrot Rock", desc: "Walk across to this small rock island for a unique viewpoint overlooking Mirissa Beach." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Experience an exciting wildlife safari where you can spot elephants, leopards, and many other animals." },
        { title: "Jeep Safari Ride", desc: "Travel through the park in a 4x4 jeep guided by an expert for the best wildlife viewing experience." }
      ]
    },
    {
      name: "📍 Unawatuna",
      activities: [
        { title: "Unawatuna Beach Stay", desc: "Enjoy a relaxing beach stay with calm waters, ideal for swimming and unwinding." }
      ]
    },
    {
      name: "📍 Galle",
      activities: [
        { title: "Galle Fort", desc: "Explore a historic colonial fort with charming streets, ocean views, cafes, and boutique shops." }
      ]
    },
    {
      name: "📍 Colombo / Airport",
      activities: [
        { title: "City Transit & Departure", desc: "Comfortable transfer to Colombo or the airport with optional city views along the way." }
      ]
    }
  ],
  package3Activities: "Activities",
  
  
  // Package tags
  hotel: "Hotel",
  transport: "Transport",
  cultural: "Cultural",
  shopping: "Shopping",
  hillCountry: "Hill Country",
  teaPlantations: "Tea Plantations",
  sigiriya: "Sigiriya",
  kandy: "Kandy",
  ella: "Ella",
  mirissa: "Mirissa",
  yala: "Yala",
  galle: "Galle",
  colombo: "Colombo",
  bentota: "Bentota",
  kitulgala: "Kitulgala",
  arugamBay: "Arugam Bay",
  beach: "Beach",
  adventure: "Adventure",
  heritageSites: "Heritage Sites",
  safari: "Safari",
  wildlife: "Wildlife",
  
  // Package titles (short version for cards)
  package1: "Kandy & Sigiriya Escape",
  package2: "Highlights Escape",
  package3: "Coast & Safari Escape",

  // Package 4
  package4Title: "Ultimate Sri Lanka Escape",
  package4Duration: "4 nights 5 days",
  package4Charges: "Hotel and transport charges only",
  package4Hotel: "4 star hotel include bed, dinner & breakfast",
  package4Price: "Starting From: USD 990\nper 2 persons",
  package4Locations: [
    {
      name: "📍 Bentota",
      activities: [
        { title: "Bentota River Boat Safari", desc: "Enjoy a relaxing boat ride through scenic mangroves where you can spot birds, monitor lizards, and other wildlife." }
      ]
    },
    {
      name: "📍 Mirissa",
      activities: [
        { title: "Mirissa Beach", desc: "Unwind on a beautiful sandy beach with clear waters, perfect for swimming and relaxing under the sun." },
        { title: "Coconut Tree Hill", desc: "Visit a famous viewpoint lined with coconut trees, offering stunning ocean views and great photo opportunities." },
        { title: "Parrot Rock", desc: "Walk across shallow waters to this small rock island for a unique perspective of Mirissa Beach." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "See the iconic stone bridge surrounded by lush greenery, a must-visit spot for photos and train sightings." },
        { title: "Ravana Pool Club", desc: "Relax in a stylish pool setting with mountain views, music, and a laid-back atmosphere." },
        { title: "Ravana Ella Waterfall", desc: "Stop by this impressive waterfall cascading down rocky cliffs, perfect for photos and a quick refresh." }
      ]
    },
    {
      name: "📍 Nuwara Eliya",
      activities: [
        { title: "Gregory Lake", desc: "Spend time by a peaceful lake where you can enjoy cool weather, boat rides, and outdoor activities." },
        { title: "Victoria Park", desc: "Take a relaxing walk through a well-kept park filled with colorful flowers and natural beauty." }
      ]
    }
  ],
  package4Activities: "Activities",
  package4: "Ultimate Escape",

  // Package 5
  package5Title: "Ultimate Adventure Trail",
  package5Duration: "5 nights 6 days",
  package5Charges: "Hotel and transport charges only",
  package5Hotel: "4 star hotel include bed, dinner & breakfast",
  package5Price: "Starting From: USD 1390\nper 2 persons",
  package5Locations: [
    {
      name: "📍 Kitulgala",
      activities: [
        { title: "White Water Rafting", desc: "Experience an exciting rafting adventure through river rapids surrounded by lush rainforest scenery." }
      ]
    },
    {
      name: "📍 Ella",
      activities: [
        { title: "Nine Arch Bridge", desc: "Visit one of Sri Lanka’s most famous landmarks, ideal for photography and watching trains pass through." },
        { title: "Ravana Pool Club", desc: "Enjoy a refreshing break at a scenic pool club with great views and a relaxing vibe." },
        { title: "Ravana Ella Waterfall", desc: "Admire the beauty of this popular waterfall and take memorable photos in a natural setting." }
      ]
    },
    {
      name: "📍 Arugam Bay",
      activities: [
        { title: "Arugam Bay Beach", desc: "Relax on a world-famous beach known for its laid-back vibe, golden sand, and surf-friendly waves." },
        { title: "Elephant Rock", desc: "Take a short tuk ride and hike to this viewpoint for stunning sunrise or sunset views over the coastline." }
      ]
    },
    {
      name: "📍 Yala",
      activities: [
        { title: "Yala National Park Safari", desc: "Go on a thrilling safari to spot wildlife such as elephants, leopards, and a variety of birds." },
        { title: "Jeep Safari Experience", desc: "Explore the park in a 4x4 jeep with an experienced driver for the best chance of seeing animals up close." }
      ]
    },
    {
      name: "📍 Bentota (Return Stop)",
      activities: [
        { title: "Bentota Boat Ride", desc: "Enjoy another calm and scenic river boat ride, perfect for relaxing before heading to the airport." }
      ]
    }
  ],
  package5Activities: "Activities",
  package5: "Adventure Trail",

};
